<template>
  <div class="login-page">
    <div class="login-container">
      <div class="positioning-centered bg-white radius-10 w-581 h-400 padding-top-66">
        <div class="text-main font-size-40 text-bold text-center padding-lr-66 shadow-blur">
          在线教育
        </div>
        <div class="w-449 padding-lr-66 margin-top-45">
          <el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="demo-ruleForm">
            <el-form-item label="" prop="account">
              <el-input placeholder="请输入账号" type="text" v-model="ruleForm.account" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="" prop="password">
              <el-input placeholder="请输入密码" :type="showPassword ? 'text' : 'password'" v-model="ruleForm.password"
                autocomplete="off">
                <img slot="suffix" :src="showPassword
                  ? require('@/assets/icon29.png')
                  : require('@/assets/icon.png')
                  " @click="togglePassword" style="
                   cursor: pointer;
                   width: 20px;
                   height: 20px;
                   display: block;
                   margin: 0 auto;
                 " />
              </el-input>
            </el-form-item>
            <el-form-item prop="privacyAgreement">
              <div class="privacy-agreement-wrapper">
                <el-checkbox v-model="ruleForm.privacyAgreement">
                  我已阅读并同意
                </el-checkbox>
                <span class="privacy-link" @click="viewPrivacyAgreement">《隐私协议》</span>
              </div>
            </el-form-item>
            <el-form-item>
              <el-button :loading="loading" type="primary" class="custom-button-common"
                @click="submitForm('ruleForm')">登录</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>

    
    <el-dialog :title="privacyTitle" :visible.sync="showPrivacyDialog" width="600px" :close-on-click-modal="false">
      <div v-loading="loadingPrivacy" class="privacy-content">
        <div v-if="privacyContent" v-html="privacyContent"></div>
        <div v-else-if="!loadingPrivacy" class="no-content">暂无内容</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="showPrivacyDialog = false">我知道了</el-button>
      </span>
    </el-dialog>

    
    <el-dialog :visible.sync="activating" width="400px" :close-on-click-modal="false" :show-close="true" title="账号激活">
      <div class="activating-content">
        <div class="text-center">
          <div class="padding-top-20 text-18 text-000-color">您的账号尚未激活，请点击下方按钮进行激活</div>
          <div class="padding-top-30">
            <el-button type="primary" :loading="activatingLoading" :disabled="countdown > 0" class="activate-button"
              @click="handleActivate">
              {{ countdown > 0 ? `激活中(${countdown}秒)` : '激活账号' }}
            </el-button>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { login, getPrivacyProtocol, activateAccount } from "@/api/auth";
import { getReviewStatus } from "@/api/common";
import { mapActions } from 'vuex'

export default {
  name: "Login",
  data() {
    var validateAccount = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入账号"));
      } else {
        callback();
      }
    };
    var validatePassword = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else {
        callback();
      }
    };
    var validatePrivacyAgreement = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请先阅读并同意隐私协议"));
      } else {
        callback();
      }
    };
    return {
      loading: false,
      activating: false,
      activatingLoading: false, 
      countdown: 0, 
      countdownTimer: null, 
      showPassword: false, 
      showPrivacyDialog: false, 
      privacyContent: "", 
      privacyTitle: '',
      loadingPrivacy: false, 
      ruleForm: {
        account: "", 
        password: "", 
        privacyAgreement: false, 
      },
      rules: {
        account: [{ validator: validateAccount, trigger: "blur" }],
        password: [{ validator: validatePassword, trigger: "blur" }],
        privacyAgreement: [{ validator: validatePrivacyAgreement, trigger: "change" }],
      },
    };
  },
  methods: {
    ...mapActions(['setLoginInfo']),
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (!valid) return false;
        this.handleLogin();
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    
    togglePassword() {
      this.showPassword = !this.showPassword;
    },
    
    viewPrivacyAgreement(event) {
      
      if (event) {
        event.stopPropagation();
        event.preventDefault();
      }
      
      if (!this.privacyContent) {
        this.loadPrivacyProtocol();
      } else {
        
        this.showPrivacyDialog = true;
      }
    },
    
    loadPrivacyProtocol() {
      this.loadingPrivacy = true;
      getPrivacyProtocol()
        .then((res) => {
          if (res.code === 1 && res.data) {
            this.privacyContent = res.data.content || "";
            this.privacyTitle = res.data.title,
              this.showPrivacyDialog = true;
          } else {
            this.$message.error(res.msg || "获取隐私协议失败");
          }
        })
        .catch((error) => {
          this.$message.error(
            (error.response &&
              error.response.data &&
              error.response.data.msg) ||
            error.msg ||
            "获取隐私协议失败，请稍后重试"
          );
        })
        .finally(() => {
          this.loadingPrivacy = false;
        });
    },
    async handleLogin() {
      this.loading = true;
      try {
        const res = await login(this.ruleForm.account, this.ruleForm.password);
        const userinfo = res.data && res.data.userinfo;
        if (!userinfo) {
          this.$message.error("未获取到用户信息，请稍后重试");
          this.loading = false;
          return;
        }

        localStorage.setItem("isLoggedIn", "true");
        localStorage.setItem("token", userinfo.token || "");
        localStorage.setItem("userInfo", JSON.stringify(userinfo));
        
        this.setLoginInfo({
          token: userinfo.token || "",
          userInfo: userinfo
        });
        
        this.$bus.$emit('user-login');

        
        try {
          const reviewRes = await getReviewStatus();
          const needReview = !!reviewRes.data;
          localStorage.setItem("need-review", needReview ? "true" : "false");
        } catch (e) {
          localStorage.setItem("need-review", "false");
        }

        
        if (userinfo.activation_status === 1) {
          
          this.activating = true;
          this.loading = false;
          return;
        }

        
        this.loading = false;
        this.$message.success(res.msg || "登录成功");
        
        this.$nextTick(() => {
          this.$router.push("/");
        });
      } catch (error) {
        
        this.loading = false;
        
        if (error && error.msg) {
          this.$message.error(error.msg);
        } else if (error && error.response && error.response.data && error.response.data.msg) {
          this.$message.error(error.response.data.msg);
        }
      } finally {
        
        if (!this.activating) {
          this.loading = false;
        }
      }
    },
    
    handleActivate() {
      
      this.countdown = 5;
      this.activatingLoading = true;

      
      this.countdownTimer = setInterval(() => {
        this.countdown--;
        if (this.countdown <= 0) {
          clearInterval(this.countdownTimer);
          this.countdownTimer = null;
          
          this.doActivate();
        }
      }, 1000);
    },
    
    doActivate() {
      activateAccount()
        .then(() => {
          this.activating = false;
          this.activatingLoading = false;
          this.countdown = 0;
          if (this.countdownTimer) {
            clearInterval(this.countdownTimer);
            this.countdownTimer = null;
          }
          this.$message.success("账号激活成功");
          
          try {
            const userInfoStr = localStorage.getItem('userInfo');
            if (userInfoStr) {
              const userInfo = JSON.parse(userInfoStr);
              userInfo.activation_status = 2; 
              localStorage.setItem('userInfo', JSON.stringify(userInfo));
              
              this.$store.commit('UPDATE_USER_INFO', { activation_status: 2 });
            }
          } catch (e) {
            console.error('更新用户信息失败:', e);
          }
          this.$nextTick(() => {
            this.$router.push("/");
          });
        })
        .catch((error) => {
          this.activatingLoading = false;
          this.countdown = 0;
          if (this.countdownTimer) {
            clearInterval(this.countdownTimer);
            this.countdownTimer = null;
          }
          this.$message.error(error.msg || "账号激活失败，请稍后重试");
        });
    },
  },
  mounted() {
    
    const isLoggedIn = localStorage.getItem("isLoggedIn");
    if (isLoggedIn === "true") {
      this.$router.push("/");
    }
  },
  beforeDestroy() {
    
    if (this.countdownTimer) {
      clearInterval(this.countdownTimer);
      this.countdownTimer = null;
    }
  },
};
</script>

<style scoped lang="scss">
.login-page {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  z-index: 9999;
}

.login-container {
  width: 100%;
  height: 100vh;
  background-image: url("@/assets/bg.png");
  background-size: 100% 100%;
}

::v-deep .el-input__inner {
  height: 61px !important;
}

::v-deep .el-input__suffix {
  width: 48px;
  padding-right: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.privacy-agreement-wrapper {
  display: flex;
  align-items: center;
  gap: 4px;
}

.privacy-link {
  color: #409eff;
  cursor: pointer;
}

.privacy-content {
  padding: 20px 0;
  line-height: 1.6;
  color: #606266;
  max-height: 500px;
  overflow-y: auto;
  min-height: 200px;

  p {
    margin-bottom: 10px;
  }

  .no-content {
    text-align: center;
    color: #909399;
    padding: 40px 0;
  }

  :deep(h1),
  :deep(h2),
  :deep(h3),
  :deep(h4),
  :deep(h5),
  :deep(h6) {
    margin: 16px 0;
    font-weight: 600;
  }

  :deep(p) {
    margin: 10px 0;
  }

  :deep(ul),
  :deep(ol) {
    margin: 10px 0;
    padding-left: 30px;
  }

  :deep(li) {
    margin: 5px 0;
  }
}

::v-deep .el-form-item {
  margin-bottom: 20px;
}

::v-deep .el-checkbox {
  font-size: 14px;
}

.activating-content {
  padding: 40px 20px;
  min-height: 150px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.activate-button {
  width: 200px;
  height: 45px;
  font-size: 18px;
  border-radius: 25px;
  background: #2342c9;
}

@media (min-width: 768px) and (max-width: 1440px) {
  .login-page {
    .w-581 {
      width: 500px !important;
    }

    .h-400 {
      height: auto !important;
      min-height: 380px !important;
      padding-bottom: 40px !important;
    }

    .padding-top-66 {
      padding-top: 40px !important;
    }

    .font-size-40 {
      font-size: 32px !important;
    }

    .w-449 {
      width: 380px !important;
    }

    .margin-top-45 {
      margin-top: 30px !important;
    }

    .custom-button-common {
      width: 350px !important;
      height: 48px !important;
    }
  }

  .privacy-content {
    max-height: 400px !important;
  }

  ::v-deep {
    .el-dialog {
      width: 85% !important;
    }
  }
}

@media (min-width: 768px) and (max-width: 1024px) {
  .login-page {
    .w-581 {
      width: 450px !important;
    }

    .h-400 {
      height: auto !important;
      min-height: 350px !important;
      padding-bottom: 35px !important;
    }

    .padding-top-66 {
      padding-top: 35px !important;
    }

    .font-size-40 {
      font-size: 28px !important;
    }

    .w-449 {
      width: 340px !important;
    }

    .custom-button-common {
      width: 320px !important;
      height: 45px !important;
    }
  }
}

@media (min-width: 1024px) and (max-width: 1440px) {
  .login-page {
    .w-581 {
      width: 520px !important;
    }

    .h-400 {
      height: auto !important;
      min-height: 390px !important;
      padding-bottom: 45px !important;
    }
  }
}

::v-deep .el-icon-loading {
  animation: rotating 2s linear infinite;
}

@keyframes rotating {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
</style>
